<template>
  <div class="row" id="DeleteMultiples">
    <div class="col-md-12 pt-0 pb-0">
      <WarningMessage
        class="text-center"
        :message="`Será excluido ${itemsSelected.length} lançamento(s).`"
      />
    </div>
    <div class="col-md-12 pt-0 pb-0 border-bottom">
      <div class="row m-0">
        <div class="col-md-2 pt-0 pb-0">Data de vencimento</div>
        <div class="col-md-7 pt-0 pb-0">Descrição</div>
        <div class="col-md-2 pt-0 pb-0">Valor</div>
        <div class="col-md-1 pt-0 pb-0">Status</div>
      </div>
    </div>
    <div class="col-md-12 pt-0 pb-0 itemsSelected">
      <div
        class="row m-0 border-bottom"
        v-for="(item, key) in itemsSelected"
        :key="key"
      >
        <div class="col-md-2 pt-0 pb-0">{{ item.date }}</div>
        <div class="col-md-7 pt-0 pb-0">{{ item.description }}</div>
        <div class="col-md-2 pt-0 pb-0">
          <span v-if="item.is_spent_or_gain == 'CREDITO'" class="c-success">
            {{ formatMoney(String(item.value).replace("-", "")) }}
          </span>
          <span v-if="item.is_spent_or_gain == 'DEBITO'" class="c-danger">
            -{{ formatMoney(String(item.value).replace("-", "")) }}
          </span>
        </div>
        <div class="col-md-1 pt-0 pb-0">
          <span v-if="item.is_spent_or_gain == 'CREDITO'">
            {{ item.is_paid == 1 ? "Recebido" : "Receber" }}
          </span>
          <span v-if="item.is_spent_or_gain == 'DEBITO'">
            {{ item.is_paid == 1 ? "Pago" : "Pagar" }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-md-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <v-btn :disabled="loading" class="btn-cancel" @click="$emit('cancel')"
        >CANCELAR</v-btn
      >
    </div>
    <div class="col-md-6 pt-0 pb-0 text-right">
      <ConfirmationDialog
        :disabled="loading"
        :loading="loading"
        headerClass="modal-header-i"
        message-title="EXCLUIR?"
        :message-body="`Deseja realmente excluir o(s) lançamento(s) selecionado(s)?`"
        open-class="btn-delete"
        open-left-icon="fa-times"
        openText="EXCLUIR"
        @yes="handleDelete"
      />
    </div>
  </div>
</template>

<script>
import WarningMessage from "../../../../Components/WarningMessage";

import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import { formatMoney } from "../../../../../lib/format";

export default {
  name: "DeleteMultiples",
  components: {
    WarningMessage,
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    itemsSelected: Array,
  },
  data() {
    return {
      errors: [],
      loading: false,
    };
  },
  methods: {
    formatMoney,
    async handleDelete() {
      try {
        this.loading = true;

        const { itemsSelected } = this;

        let data = { itemsSelected };

        const response = await api.delete(
          "/rest-home/financial/launch/finance-launch-bills-to-pay-installments/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
#DeleteMultiples .itemsSelected {
  height: 300px !important;
  overflow-y: scroll;
  z-index: 999;
}
</style>